import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { BranchModel } from '@shared/models/branch.model';
import { branchSupportsOrders } from '@shared/utils/branch-orders-available.util';

/**
 * Protects the orders route: when the selected branch is MENU_ONLY,
 * `/orders` is blocked and the user is redirected to menus.
 */
@Injectable({ providedIn: 'root' })
export class OrdersBranchGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    let branch: BranchModel | null = null;
    try {
      branch = JSON.parse(localStorage.getItem('branch') ?? 'null');
    } catch {
      branch = null;
    }
    if (branchSupportsOrders(branch)) {
      return true;
    }
    // Branch has no orders: land on menus instead
    return this.router.createUrlTree(['/menus']);
  }
}
